<script type="text/javascript">
	import { onMount } from "svelte";
	import { get, writable } from "svelte/store";

	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	import roundFloat from "../../../Helpers/Misc/roundFloat";
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import RangeRingStore from "./Store";

	// Store value
	export let data; // RangeRing object
	export let paddingBottom = true;
	export let editableLngLat = false;

	// Store references on data structure.
	let metaIndex = data.meta.index;
	let metaColor = data.meta.color;
	let inputLng = data.input.lng;
	let inputLat = data.input.lat;
	let inputTime = data.input.time;
	let inputSpeed = data.input.speed;
	let resultNM = data.result.distance.nauticalMiles;
	let resultKM = data.result.distance.km;
	let error = data.error;

	let recalc = () => {
		data.recalculate();
		dispatch('change');
	}

	$: {
		$inputLng;
		$inputLat;
		$inputTime;
		$inputSpeed;
		recalc();
	}


</script>

<style type="text/scss">
	.range-ring-view {
		padding-bottom:10px;
	}
</style>

<div class='range-ring-view' class:pb-0={!paddingBottom}>
	<h2 style="color:{$metaColor};">Range Ring #{metaIndex + 1}</h2>

	<!-- we may want to be able to set "independent" range rings (not linked to measure tool) in the future -->
	{#if editableLngLat}
		<Textfield
			dense
			variant="filled"
			label="Lng,lat (test)"
			style="width:100%"
			value={"lnglat"}
			/>
	<!-- {:else} -->
		<!-- <p>{roundFloat($inputLng,2)},{roundFloat($inputLat,2)}</p> -->
	{/if}

	<Textfield
		dense
		variant="filled"
		label="Time (minutes)..."
		style="width:48.5%"
		bind:value={$inputTime}
		on:keyup={recalc}
		/>

	<Textfield
		dense
		variant="filled"
		label="Speed (knots/nmph)..."
		style="width:48.5%"
		bind:value={$inputSpeed}
		on:keyup={recalc}
		/>

	{#if $error.length > 0}
		<p class="err"><b>Error: {$error}</b></p>
	{:else if $resultNM.length > 0}
		<p><b>Ring Distance:</b> {roundFloat($resultNM, 2)} nm / {roundFloat($resultKM, 2)} km</p>
	{/if}
</div>
